"use strict";
!function (e) {
  !e.Plugin && (e.Plugin = {});
  var l, o, u = function () {
  };

  function d(e, s, t) {
    if (!l) return !1;
    t = t || u;
    var c = {method: e, id: f()};
    return "function" == typeof s ? t = s : c.param = s, h.subscribe(c.id, t), l.send(JSON.stringify(c)), !0
  }

  function f() {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (e) {
      var s = 16 * Math.random() | 0;
      return ("x" == e ? s : 3 & s | 8).toString(16)
    })
  }

  Plugin.VERSION = "", Plugin.LOWVERSION = "4.0.1.3913", Plugin.CODE = {
    SUCCESS: {message: "success"},
    NOSUPPORT: {message: "不支持的浏览器"},
    LOWVERSION: {message: "卡控件版本过低，请安装最新版本卡控件"},
    NOPLUGIN: {message: "未检测到卡控件"},
    ERROR: {message: "卡操作失败"},
    DISCONNECT: {message: "卡控件连接断开，请重新初始化"},
    CONNECTFAIL: {message: "卡控件连接异常，请重新初始化"},
    NEVERINIT: {message: "插件未初始化"}
  }, Plugin.CARD_USAGE = {
    CARD_USAGE_ALL: -1,
    CARD_USAGE_ADMIN: 0,
    CARD_USAGE_USER: 1
  }, Plugin.CARD_TYPE = {
    CARD_TYPE_ALL: -1,
    CARD_TYPE_TF: 0,
    CARD_TYPE_USB: 1,
    CARD_TYPE_ACE: 2
  }, Plugin.CERT_TYPE = {CERT_ENC: 0, CERT_SIGN: 1}, Plugin.errorDesc = {
    0: "成功",
    "-19": "SM4运算失败",
    "-12": "证书格式错误",
    "-203": "容器不存在",
    "-1": "卡未插入",
    "-20": "重置PIN码失败",
    "-13": "导入证书失败",
    "-204": "容器证书内容错误",
    "-2": "参数错误",
    "-21": "创建文件失败",
    "-14": "BASE64解码失败",
    "-100": "不支持此功能",
    "-3": "未插入管理卡",
    "-22": "SM3运算失败",
    "-15": "解析pfx失败",
    "-27": "激活卡失败",
    "-4": "卡锁死",
    "-23": "SM1运算失败",
    "-16": "导入pfx失败",
    "-29": "未激活",
    "-5": "口令错误",
    "-24": "PSA私钥运算失败",
    "-17": "读卡文件失败",
    "-31": "手机驱动安装失败",
    "-6": "卡内产生公私钥对失败",
    "-25": "获取设备信息失败",
    "-18": "导入密钥失败",
    "-33": "获取设备号失败",
    "-7": "新建容器失败",
    "-61": "解析网关证书失败",
    "-26": "产生随机数失败",
    "-35": "导入公钥失败",
    "-8": "容器不存在",
    "-62": "签名失败",
    "-28": "获取卡激活状态失败",
    "-37": "公钥运算失败",
    "-9": "绑定用户卡失败",
    "-63": "取消签名失败",
    "-30": "ADB 端口被占用",
    "-39": "SM2运算失败",
    "-10": "文件不存在",
    "-99": "内部错误",
    "-36": "导入私钥失败",
    "-38": "私钥运算失败",
    "-11": "写文件失败",
    "-101": "内存申请失败",
    "-32": "卸载安通助手失败",
    "-34": "开启安通助手失败",
    "-43": "解锁加密盘失败"
  }, Plugin.init = function (s) {
    if (l) return s.call(this, {code: Plugin.CODE.SUCCESS});
    var t;
    if (window.ActiveXObject || "ActiveXObject" in window) try {
      return Plugin.type = "activeX", l = new ActiveXObject("CardCert.WriteCard"), Plugin.VERSION = l.test(), -1 == r(Plugin.VERSION, Plugin.LOWVERSION) ? (l = void 0, s.call(this, {code: Plugin.CODE.LOWVERSION})) : s.call(this, {code: Plugin.CODE.SUCCESS})
    } catch (e) {
      return s.call(this, {code: Plugin.CODE.NOPLUGIN})
    } else {
      if (!(window.MozWebSocket && (t = window.MozWebSocket) || window.WebSocket && (t = window.WebSocket))) return s.call(this, {code: Plugin.CODE.NOSUPPORT});
      try {
        (l = new t("ws://localhost:8000/xdja/server")).onopen = function (e) {
          Plugin.type = "ws", d("Test", function (e) {
            return Plugin.VERSION = e, -1 == r(Plugin.VERSION, Plugin.LOWVERSION) ? s.call(this, {code: Plugin.CODE.LOWVERSION}) : ((o = new t("ws://localhost:8000/xdja/server")).onmessage = function (s) {
              var e;
              try {
                e = JSON.parse(s.data)
              } catch (e) {
                console.log("exception==>" + s.data + "----" + e)
              }
              if (e && e.id) {
                var t = e.state ? e.result : {
                  error: {
                    code: e.result,
                    message: Plugin.errorDesc[e.result] || "未知错误",
                    success: e.state
                  }
                };
                h.publish(e.id, t)
              }
            }, s.call(this, {code: Plugin.CODE.SUCCESS}))
          })
        }, l.onclose = function (e) {
          l = void 0
        }, l.onerror = function (e) {
          return l = void 0, s.call(this, {code: Plugin.CODE.NOPLUGIN})
        }, l.onmessage = function (s) {
          var e;
          try {
            e = JSON.parse(s.data)
          } catch (e) {
            console.log("exception==>" + s.data + "----" + e)
          }
          if (e && e.id) {
            var t = e.state ? e.result : {
              error: {
                code: e.result,
                message: Plugin.errorDesc[e.result] || "未知错误",
                success: e.state
              }
            };
            h.publish(e.id, t)
          }
        }
      } catch (e) {
        return s.call(this, {code: Plugin.CODE.NOPLUGIN})
      }
    }
  }, Plugin.getVersion = function (e) {
    Plugin && Plugin.type && ("activeX" == Plugin.type ? e.call(this, l.Test()) : d("Test", e))
  }, Plugin.getCards = function (t, e, s) {
    if ("function" != typeof t && (t = u), -1 == [-1, 0, 1, 2].indexOf(e) && (e = -1), -1 == [-1, 0, 1].indexOf(s) && (s = -1), Plugin && Plugin.type) if ("activeX" == Plugin.type) {
      var c = l.GetAllCards(e, s);
      c = c ? c.split("#") : [];
      var r = [];
      0 < c.length && c.forEach(function (e) {
        r.push(new n(e))
      }), t.call(this, r)
    } else d("GetAllCards", {type: e, usage: s}, function (e) {
      var s = [];
      0 < (c = e.error ? [] : e.split("#")).length && c.forEach(function (e) {
        s.push(new i(e))
      }), t.call(this, s)
    }); else t.call(this, {code: Plugin.CODE.NEVERINIT})
  };
  var t, c, h = (t = {}, c = {
    subscribe: function (e, s) {
      t[e] || (t[e] = []), t[e].push(s)
    }, unSubscribe: function (e) {
      delete t[e]
    }, publish: function (e, s) {
      t[e] && (t[e].forEach(function (e) {
        e.call(this, s)
      }), c.unSubscribe(e))
    }
  });

  function r(e, s) {
    if (e == s) return 0;
    var t = e.split("."), c = s.split(".");
    for (var r in t) {
      if (!(r < c.length)) return 1;
      if (t[r] > c[r]) return 1;
      if (t[r] < c[r]) return -1
    }
    return 0
  }

  function i(e) {
    this.cardId = e
  }

  function n(e) {
    this.cardId = e
  }

  i.prototype.getCardId = function (e) {
    "function" != typeof e && (e = u);
    if (this.cardId) {
      var s = {success: !0, cardId: this.cardId};
      return e.call(this, s), s
    }
    e.call(this, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.getCardInfo = function (c) {
    "function" != typeof c && (c = u);
    var r = this;
    this.cardId ? d("GetCardInfo", {cardid: this.cardId}, function (e) {
      if (e.error) return c.call(r, e.error);
      var s = e.split("#"),
        t = {success: !0, type: s[0], usage: s[1], container: 3 == s.length ? s[2].match(/\d{1}/g) : []};
      c.call(r, t)
    }) : c.call(r, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.getCert = function (e, t) {
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? d("GetCert", {cardid: this.cardId, containerid: e}, function (e) {
      if (e.error) return t.call(c, e.error);
      var s = {success: !0, cert: e};
      t.call(c, s)
    }) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.adFileSign = function (e, s, t) {
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? d("AdFileSign", {cardid: this.cardId, filepath1: e, filepath2: s}, function (e) {
      if (e.error) return t.call(c, e.error);
      t.call(c, {success: !0})
    }) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.calcFile = function (e, t) {
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? 0 != e.size ? 500 < e.size / 1024 / 1024 ? t.call(c, {
      success: !1,
      message: "所选文件大小不能超过500M"
    }) : function (e, a) {
      if (!o) return;
      a = a || u;
      var l = new FileReader;
      l.readAsArrayBuffer(e), l.onload = function () {
        var e = l.result, s = new Int8Array(e), t = f();
        h.subscribe(t, a);
        var c = new Int8Array(3 + t.length);
        c[0] = "i".charCodeAt(0), c[1] = "d".charCodeAt(0), c[2] = t.length;
        for (var r = t.split(""), i = 0; i < r.length; i++) r[i] = t.charCodeAt(i);
        c.set(r, 3);
        var n = function (e) {
          for (var s = 0, t = 1; t < arguments.length; t++) s += arguments[t].length;
          var c = new e(s), r = 0;
          for (t = 1; t < arguments.length; t++) c.set(arguments[t], r), r += arguments[t].length;
          return c
        }(Int8Array, c, s).buffer;
        o.send(n), n = e = s = null
      }
    }(e, function (e) {
      if (e.error) return t.call(c, e.error);
      var s = {success: !0, digest: (e = JSON.parse(e)).digest, simpleDigest: e.simpleDigest};
      t.call(c, s)
    }) : t.call(c, {success: !1, message: "文件为空"}) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.safePin = function (e, s, t) {
    if (2 == arguments.length) t = s, s = 1; else if (arguments.length < 2) return void console.log("参数错误");
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? 0 != /^\d{3,16}$/.test(e) ? d("SafePin", {cardid: this.cardId, pin: e, role: s}, function (e) {
      if (e.error) return t.call(c, e.error);
      var s = e;
      s = 0 == s ? {success: !0} : 0 < s ? {success: !1, code: s, message: "PIN码错误，剩余" + s + "次机会"} : {
        success: !1,
        code: s,
        message: Plugin.errorDesc[s] || "未知错误"
      }, t.call(c, s)
    }) : t.call(c, {success: !1, message: "PIN码错误"}) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.safeChangePin = function (e, s, t, c) {
    var r = /^\d{3,16}$/;
    if (3 == arguments.length) c = t, t = 1; else if (arguments.length < 3) return void console.log("参数错误");
    "function" != typeof c && (c = u);
    var i = this;
    this.cardId ? 0 != r.test(e) ? 0 != r.test(s) ? d("SafeChangePin", {
      cardid: this.cardId,
      oldPin: e,
      newPin: s,
      role: t
    }, function (e) {
      if (e.error) return c.call(i, e.error);
      var s = e;
      s = 0 == s ? {success: !0} : 0 < s ? {success: !1, code: s, message: "PIN码错误，剩余" + s + "次机会"} : {
        success: !1,
        code: s,
        message: Plugin.errorDesc[s] || "未知错误"
      }, c.call(i, s)
    }) : c.call(i, {success: !1, message: "新pin码只能是3-16位数字"}) : c.call(i, {
      success: !1,
      message: "原PIN码错误"
    }) : c.call(i, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.getPinTryCount = function (e, t) {
    if (1 == arguments.length) t = e, e = 1; else if (arguments.length < 1) return void console.log("参数错误");
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? d("GetPinTryCount", {cardid: this.cardId, pinrole: e}, function (e) {
      if (e.error) return t.call(c, e.error);
      var s = e;
      s = 0 <= s ? {success: !0, count: s} : {
        success: !1,
        code: s,
        message: Plugin.errorDesc[s] || "未知错误"
      }, t.call(c, s)
    }) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.importKeyCertEx = function (e, s, t, c) {
    var r;
    r = 4 == s || 6 == s ? 17 : 1, "function" != typeof c && (c = u);
    var i = this;
    this.cardId ? d("ImportKeyCertEx", {
      cardid: this.cardId,
      role: r,
      pin: e,
      containerid: s,
      certusage: t
    }, function (e) {
      if (e.error) return c.call(i, e.error);
      var s = e;
      s = 0 == s ? {success: !0} : {success: !1, code: s, message: Plugin.errorDesc[s] || "未知错误"}, c.call(i, s)
    }) : c.call(i, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.writeCert = function (e, s, t, c, r) {
    "function" != typeof r && (r = u);
    var i = this;
    this.cardId ? d("WriteCert", {
      cardid: this.cardId,
      password: e,
      containerid: s,
      certusage: t,
      cert: c
    }, function (e) {
      if (e.error) return r.call(i, e.error);
      var s = e;
      s = 0 == s ? {success: !0} : {success: !1, code: s, message: Plugin.errorDesc[s] || "未知错误"}, r.call(i, s)
    }) : r.call(i, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.importAsymKey = function (e, s, t, c, r, i, n) {
    "function" != typeof n && (n = u);
    var a = this;
    this.cardId ? d("ImportAsymKey", {
      cardid: this.cardId,
      role: e,
      password: s,
      containernum: t,
      alg: c,
      usage: r,
      keybuf: i
    }, function (e) {
      if (e.error) return n.call(a, e.error);
      var s = e;
      s = 0 == s ? {success: !0, data: e} : {success: !1, code: s, message: Plugin.errorDesc[s] || "未知错误"}, n.call(a, s)
    }) : n.call(a, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.genKeypair = function (e, s, t, c, r, i) {
    "function" != typeof i && (i = u);
    var n = this;
    this.cardId ? d("GenKeypair", {
      cardid: this.cardId,
      password: e,
      containerid: s,
      alg: t,
      certusage: c,
      keybits: r
    }, function (e) {
      if (e.error) return i.call(n, e.error);
      var s = {success: !0, publicKey: e};
      i.call(n, s)
    }) : i.call(n, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.pullCard = function (s) {
    "function" != typeof s && (s = u);
    var t = this;
    if (this.cardId) if (this.pullCb) this.pullCb = s; else {
      this.pullCb = s;
      var c, r = function (s) {
        s.pullCb ? d("GetCosVer", {handle: s.handle}, function (e) {
          e.error && (clearInterval(c), s.pullCb.call(s, {
            success: !0,
            cardId: s.cardId
          }), s.handle = void 0, s.cardId = void 0, s.pullCb = void 0)
        }) : clearInterval(c)
      };
      if (!this.handle) try {
        d("GetCardHandle", {cardid: this.cardId}, function (e) {
          if (e.error) return s.call(t, e.error);
          t.handle = e, c = setInterval(r, 1e3, t)
        })
      } catch (e) {
        s.call(t, {success: !1, message: "获取卡句柄失败"})
      }
    } else s.call(t, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.pullCardDestroy = function (e) {
    "function" != typeof e && (e = u);
    this.pullCb = void 0, this.handle = void 0, e.call(this, {success: !0})
  }, i.prototype.getCardHandle = function (t) {
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? d("GetCardHandle", {cardid: this.cardId}, function (e) {
      if (e.error) return t.call(c, e.error);
      var s = {success: !0, handle: e};
      t.call(c, s)
    }) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, i.prototype.adDataSign = function (e, t) {
    "function" != typeof t && (t = u);
    var c = this;
    this.cardId ? d("AdDataSign", {cardid: this.cardId, instr: e}, function (e) {
      if (e.error) return t.call(c, e.error);
      var s = {success: !0, dataSign: e};
      t.call(c, s)
    }) : t.call(c, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.getCardId = function (e) {
    "function" != typeof e && (e = u);
    if (this.cardId) {
      var s = {success: !0, cardId: this.cardId};
      return e.call(this, s), s
    }
    e.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.getCardInfo = function (e) {
    "function" != typeof e && (e = u);
    if (this.cardId) {
      var s = l.GetCardInfo(this.cardId).split("#"),
        t = {success: !0, type: s[0], usage: s[1], container: 3 == s.length ? s[2].match(/\d{1}/g) : []};
      return e.call(this, t), t
    }
    e.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.getCert = function (e, s) {
    "function" != typeof s && (s = u);
    if (this.cardId) {
      var t = l.GetCert(this.cardId, e), c = parseInt(t);
      return c = 0 <= c ? {success: !0, cert: t} : {
        success: !1,
        code: c,
        message: Plugin.errorDesc[c] || "未知错误"
      }, s.call(this, c), c
    }
    s.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.adFileSign = function (e, s, t) {
    "function" != typeof t && (t = u);
    if (this.cardId) {
      var c = l.AdFileSign(this.cardId, e, s);
      return c = 0 == c ? {success: !0} : {
        success: !1,
        code: c,
        message: Plugin.errorDesc[c] || "未知错误"
      }, t.call(this, c), c
    }
    t.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.safePin = function (e, s, t) {
    if (2 == arguments.length) t = s, s = 1; else if (arguments.length < 2) return void console.log("参数错误");
    "function" != typeof t && (t = u);
    if (this.cardId) {
      if (0 != /^\d{3,16}$/.test(e)) {
        var c;
        try {
          c = 0 == (c = l.SafePin(this.cardId, e, s)) ? {success: !0} : 0 < c ? {
            success: !1,
            code: c,
            message: "PIN码错误，剩余" + c + "次机会"
          } : {success: !1, code: c, message: Plugin.errorDesc[c] || "未知错误"}
        } catch (e) {
          c = {success: !1, code: -500, message: "未知错误"}
        }
        return t.call(this, c), c
      }
      t.call(this, {success: !1, message: "PIN码错误"})
    } else t.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.safeChangePin = function (e, s, t, c) {
    var r = /^\d{3,16}$/;
    if (3 == arguments.length) c = t, t = 1; else if (arguments.length < 3) return void console.log("参数错误");
    "function" != typeof c && (c = u);
    if (this.cardId) if (0 != r.test(e)) {
      if (0 != r.test(s)) {
        var i;
        try {
          i = 0 == (i = l.SafeChangePin(this.cardId, e, s, t)) ? {success: !0} : 0 < i ? {
            success: !1,
            code: i,
            message: "PIN码错误，剩余" + i + "次机会"
          } : {success: !1, code: i, message: Plugin.errorDesc[i] || "未知错误"}
        } catch (e) {
          i = {success: !1, code: -500, message: "未知错误"}
        }
        return c.call(this, i), i
      }
      c.call(this, {success: !1, message: "新pin码只能是3-16位数字"})
    } else c.call(this, {success: !1, message: "原PIN码错误"}); else c.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.getPinTryCount = function (e, s) {
    if (1 == arguments.length) s = e, e = 1; else if (arguments.length < 1) return void console.log("参数错误");
    "function" != typeof s && (s = u);
    if (this.cardId) {
      var t;
      try {
        t = 0 <= (t = l.GetPinTryCount(this.cardId, e)) ? {success: !0, count: t} : {
          success: !1,
          code: t,
          message: Plugin.errorDesc[t] || "未知错误"
        }
      } catch (e) {
        t = {success: !1, code: -500, message: "未知错误"}
      }
      return s.call(this, t), t
    }
    s.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.importKeyCertEx = function (e, s, t, c) {
    var r;
    r = 4 == s || 6 == s ? 17 : 1, "function" != typeof c && (c = u);
    if (this.cardId) {
      var i = l.ImportKeyCertEx(this.cardId, e, r, s, t);
      return i = i ? {success: !1, code: i, message: Plugin.errorDesc[i] || "未知错误"} : {success: !0}, c.call(this, i), i
    }
    c.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.pullCard = function (s) {
    "function" != typeof s && (s = u);
    var t = this;
    if (this.cardId) {
      if (!this.handle) try {
        this.handle = l.GetCardHandle(this.cardId)
      } catch (e) {
        s.call(t, {success: !1, message: "获取卡句柄失败"})
      }
      if (this.pullCb) this.pullCb = s; else {
        this.pullCb = s;
        var c, r;
        c = setInterval(function (e) {
          if (e.pullCb) {
            try {
              l.GetCosVer(e.handle) || (r = !0)
            } catch (e) {
              r = !0
            }
            r && (clearInterval(c), e.pullCb.call(e, {
              success: !0,
              cardId: e.cardId
            }), e.handle = void 0, e.cardId = void 0, e.pullCb = void 0)
          } else clearInterval(c)
        }, 1e3, this)
      }
    } else s.call(t, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.pullCardDestroy = function (e) {
    "function" != typeof e && (e = u);
    this.pullCb = void 0, this.handle = void 0, e.call(this, {success: !0})
  }, n.prototype.calcFile = function (e, s) {
    "function" != typeof s && (s = u);
    this.cardId ? 0 != e.size ? 500 < e.size / 1024 / 1024 ? s.call(this, {
      success: !1,
      message: "所选文件大小不能超过500M"
    }) : s.call(this, {success: !1, message: "该卡控件不支持IE浏览器获取文件摘要"}) : s.call(this, {
      success: !1,
      message: "文件为空"
    }) : s.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.writeCert = function (e, s, t, c, r) {
    "function" != typeof r && (r = u);
    if (this.cardId) {
      var i = l.writeCert(this.cardId, e, s, t, c);
      return i = i ? {success: !1, code: i, message: Plugin.errorDesc[i] || "未知错误"} : {success: !0}, r.call(this, i), i
    }
    r.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.importAsymKey = function (e, s, t, c, r, i, n) {
    "function" != typeof n && (n = u);
    if (this.cardId) {
      var a = {success: !0, str: l.ImportAsymKey(this.cardId, e, s, t, c, r, i)};
      return n.call(this, a), a
    }
    n.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.genKeypair = function (e, s, t, c, r, i) {
    "function" != typeof i && (i = u);
    if (this.cardId) {
      var n = {success: !0, publicKey: l.GenKeypair(this.cardId, e, s, t, c, r)};
      return i.call(this, n), n
    }
    i.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.getCardHandle = function (e) {
    "function" != typeof e && (e = u);
    if (this.cardId) {
      var s = {success: !0, handle: l.getCardHandle(this.cardId)};
      return e.call(this, s), s
    }
    e.call(this, {success: !1, message: "卡对象已销毁"})
  }, n.prototype.adDataSign = function (e, s) {
    "function" != typeof s && (s = u);
    if (this.cardId) {
      var t = {success: !0, dataSign: l.AdDataSign(this.cardId, e)};
      return s.call(this, t), t
    }
    s.call(this, {success: !1, message: "卡对象已销毁"})
  }
}(window);
